import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "../../../../../components/Icon";

const GRID_SLIDER_DIRECTION = {
  previous: "prev",
  next: "next"
};

const SampleReportGrid = ({ grid, data, gridPageSize = 5, alignMiddle = false }) => {
  const [startItem, setPage] = useState(0);
  const endItem = startItem + gridPageSize;

  const changePage = (start, direction) => {
    const newStart =
      direction === GRID_SLIDER_DIRECTION.next
        ? start + gridPageSize
        : start - gridPageSize;
    setPage(newStart);
  };

  const viewingFirstPage = startItem === 0;
  const viewingLastPage = endItem >= data.length;
  const showNavigation = data.length > gridPageSize;

  const gridData = data.slice(startItem, endItem);
  const gridColumnHeadings = grid.fields.map((item, idx) => {
    const { heading, pageHeadingComponent, width } = item;
    const columnWidth = width ? { width } : {};
    return (
      <th key={idx} style={columnWidth}>
        {heading}
        {pageHeadingComponent &&
          gridData.map((row, pageHeadingIdx) => (
            <React.Fragment key={pageHeadingIdx}>
              {pageHeadingComponent(row)}
            </React.Fragment>
          ))}
      </th>
    );
  });

  return (
    <>
      <table
        className={`sample-report-grid ${
          alignMiddle && "sample-report-grid--align-middle"
        }`}
      >
        <thead>
          <tr>{gridColumnHeadings}</tr>
        </thead>
        <tbody>
          {gridData.map((row, rowIndex) => (
            <tr key={rowIndex + startItem}>
              {grid.fields.map((field, fieldIndex) => (
                <td
                  key={fieldIndex}
                  className={`sample-report-grid__cell ${
                    field.extraPadding
                      ? "sample-report-grid__cell--extra-right-padding"
                      : ""
                  }`}
                >
                  {field?.component(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {showNavigation && (
        <div className="sample-report-grid__nav">
          <span
            onClick={() =>
              !viewingFirstPage &&
              changePage(startItem, GRID_SLIDER_DIRECTION.previous)
            }
            className={`sample-report-grid__nav-item ${
              viewingFirstPage && "disabled"
            }`}
          >
            <Icon name="prev" />
          </span>
          <span
            onClick={() =>
              !viewingLastPage &&
              changePage(startItem, GRID_SLIDER_DIRECTION.next)
            }
            className={`sample-report-grid__nav-item ${
              viewingLastPage && "disabled"
            }`}
          >
            <Icon name="next" />
          </span>
        </div>
      )}
    </>
  );
};

SampleReportGrid.propTypes = {
  grid: PropTypes.shape({
    fields: PropTypes.arrayOf(PropTypes.any)
  }),
  data: PropTypes.arrayOf(PropTypes.any),
  gridPageSize: PropTypes.number,
  alignMiddle: PropTypes.bool
};

export default SampleReportGrid;
